<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>

            <b-breadcrumb-item
              :to="{
                name: 'AutoMarketingMemberEvent',
              }"
              >會員事件設定</b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ title }} </b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>

    <div class="email-wrapper wrapper">
      <div class="row align-items-stretch">
        <div class="mail-sidebar d-none d-lg-block col-md-2 pt-3 bg-white">
          <div class="menu-bar">
            <ul class="menu-items">
              <li :class="step == '' ? 'active' : ''" @click="goToStep('')">
                <a>基本設定</a>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
              </li>
              <li
                :class="step == '#trigger' ? 'active' : ''"
                @click="goToStep('#trigger')"
              >
                <a>觸發條件</a>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
              </li>
              <li
                :class="step == '#event' ? 'active' : ''"
                @click="goToStep('#event')"
              >
                <a>執行事件內容</a>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
              </li>
            </ul>
          </div>
        </div>
        <div class="mail-view d-none d-md-block col-md-9 col-lg-10 bg-white">
          <b-card>
            <!-- 基本設定 -->
            <section class="mb-5" v-if="step == ''">
              <h4 class="mb-2 font-weight-bold">基本設定</h4>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="sm"
                label="通路"
                label-for="merchant"
              >
                <b-form-select
                  v-model="form.merchant_id"
                  :options="merchants"
                  :disabled="isFetchMerchants || isReadOnly"
                ></b-form-select>
                <b-form-invalid-feedback :state="!v$.form.merchant_id.$error"
                  >此欄位為必填</b-form-invalid-feedback
                >
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="sm"
                label="標題"
              >
                <b-form-input
                  class="mb-2 mr-sm-2 mb-sm-0"
                  type="text"
                  :state="v$.form.title.$error ? false : null"
                  v-model="form.title"
                  :readonly="isReadOnly"
                ></b-form-input>
                <b-form-invalid-feedback :state="!v$.form.title.$error">
                  此欄位為必填
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="sm"
                label="使用期間"
              >
                <div
                  class="
                    d-flex
                    flex-column flex-xl-row
                    align-items-start align-items-xl-center
                  "
                >
                  <datepicker
                    placeholder="選擇日期"
                    v-model="form.start_at"
                    bootstrap-styling
                    format="yyyy-MM-dd"
                    :language="zh"
                    :disabled="isReadOnly"
                    :disabledDates="disabledDates"
                    clear-button
                    :input-class="v$.form.start_at.$error ? 'is-invalid' : ''"
                  ></datepicker>
                  <span class="mx-2">~</span>
                  <datepicker
                    placeholder="選擇日期"
                    v-model="form.end_at"
                    bootstrap-styling
                    format="yyyy-MM-dd"
                    :language="zh"
                    :disabled="isReadOnly"
                    :disabledDates="disabledDates"
                    clear-button
                    :input-class="v$.form.end_at.$error ? 'is-invalid' : ''"
                  ></datepicker>
                </div>
                <b-form-invalid-feedback
                  :state="!v$.form.start_at.beforeEndAt.$invalid"
                >
                  結束時間必須大於起始時間
                </b-form-invalid-feedback>
              </b-form-group>
              <!-- <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="sm"
                label="類型"
              >
                <b-form-input
                  class="mb-2 mr-sm-2 mb-sm-0"
                  type="text"
                  :state="v$.form.type.$error ? false : null"
                  v-model="form.type"
                  :readonly="isReadOnly"
                ></b-form-input>
                <b-form-invalid-feedback
                  :state="!v$.form.type.$error"
                >
                  此欄位為必填
                </b-form-invalid-feedback>
              </b-form-group> -->
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="sm"
                label="是否啟用"
              >
                <b-form-checkbox
                  class="mb-2 mr-sm-2 mb-sm-0"
                  type="text"
                  :state="v$.form.is_enabled.$error ? false : null"
                  v-model="form.is_enabled"
                  :readonly="isReadOnly"
                ></b-form-checkbox>
                <b-form-invalid-feedback :state="!v$.form.is_enabled.$error">
                  此欄位為必填
                </b-form-invalid-feedback>
              </b-form-group>
              <!-- <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="sm"
                label="細節設定"
              >
                <b-form-input
                  class="mb-2 mr-sm-2 mb-sm-0"
                  type="text"
                  :state="v$.form.config.$error ? false : null"
                  v-model="form.config"
                  :readonly="isReadOnly"
                ></b-form-input>
                <b-form-invalid-feedback
                  :state="!v$.form.config.$error"
                >
                  此欄位為必填
                </b-form-invalid-feedback>
              </b-form-group> -->
              <div
                class="d-flex justify-content-center"
                style="margin-top: 100px"
              >
                <b-button
                  class="mr-3"
                  variant="outline-danger"
                  @click="goListPage"
                  >返回
                </b-button>
                <b-button
                  v-if="!isReadOnly"
                  @click="handleSubmit"
                  variant="success"
                  >儲存</b-button
                >
              </div>
            </section>

            <!-- 觸發條件 -->
            <section class="mb-5" v-if="step == '#trigger'">
              <h4 class="mb-2 font-weight-bold">觸發條件</h4>
              <div v-if="form.trigger.type" class="flex-fill">
                <!--生日-->
                <template v-if="form.trigger.type == 'birthday'">
                  <div class="form-inline mb-2">
                    <b-form-radio
                      v-model="form.trigger.value"
                      value="day"
                      @change="
                        () => {
                          form.trigger = {
                            type: form.trigger.type,
                            value: 'day',
                          };
                        }
                      "
                    ></b-form-radio>
                    每天
                  </div>

                  <div class="form-inline mb-2">
                    <b-form-radio
                      v-model="form.trigger.value"
                      value="week"
                      @change="
                        () => {
                          form.trigger = {
                            type: form.trigger.type,
                            value: 'week',
                          };
                        }
                      "
                    >
                    </b-form-radio>
                    每週
                  </div>

                  <div class="form-inline mb-2">
                    <b-form-radio
                      v-model="form.trigger.value"
                      value="month"
                      @change="
                        () => {
                          form.trigger = {
                            type: form.trigger.type,
                            value: 'month',
                          };
                        }
                      "
                    ></b-form-radio>
                    每月
                  </div>
                </template>

                <!--LINE-->
                <template v-else-if="form.trigger.type == 'line_follow'">
                  <div>加入好友立即觸發</div>
                </template>

                <!--完成註冊-->
                <template v-else-if="form.trigger.type == 'registered'">
                  <div>註冊後立即觸發</div>
                </template>

                <!--升等-->
                <template v-if="form.trigger.type == 'customer_upgraded'">
                  <div class="mb-3">升等時立即觸發</div>
                  <b-form-group
                    label-cols="12"
                    label-cols-lg="3"
                    label-size="sm"
                    label="來源等級"
                  >
                    <b-form-select
                      v-model="levelCondition.from_customer_level_id"
                      :options="fromLevelOptions"
                      :disabled="isReadOnly || isFetchCustomerLevels"
                    ></b-form-select>
                    <small class="form-text text-muted">
                      選擇性設定：指定從哪個等級升等而來，不選擇則代表任何等級升等都觸發
                    </small>
                  </b-form-group>
                  <b-form-group
                    label-cols="12"
                    label-cols-lg="3"
                    label-size="sm"
                    label="目標等級"
                  >
                    <b-form-select
                      v-model="levelCondition.to_customer_level_id"
                      :options="toLevelOptions"
                      :disabled="isReadOnly || isFetchCustomerLevels"
                    ></b-form-select>
                    <small class="form-text text-muted">
                      選擇性設定：指定升等到哪個等級時觸發，不選擇則代表升等到任何等級都觸發
                    </small>
                  </b-form-group>
                </template>

                <!--續等-->
                <template v-if="form.trigger.type == 'customer_extended'">
                  <div class="mb-3">續等時立即觸發</div>
                  <b-form-group
                    label-cols="12"
                    label-cols-lg="3"
                    label-size="sm"
                    label="續等等級"
                  >
                    <b-form-select
                      v-model="levelCondition.customer_level_id"
                      :options="extendLevelOptions"
                      :disabled="isReadOnly || isFetchCustomerLevels"
                    ></b-form-select>
                    <small class="form-text text-muted">
                      選擇性設定：指定續等哪個等級時觸發，不選擇則代表任何等級續等都觸發
                    </small>
                  </b-form-group>
                </template>

                <!--降等-->
                <template v-if="form.trigger.type == 'customer_downgraded'">
                  <div class="mb-3">降等時立即觸發</div>
                  <b-form-group
                    label-cols="12"
                    label-cols-lg="3"
                    label-size="sm"
                    label="來源等級"
                  >
                    <b-form-select
                      v-model="levelCondition.from_customer_level_id"
                      :options="fromLevelOptions"
                      :disabled="isReadOnly || isFetchCustomerLevels"
                    ></b-form-select>
                    <small class="form-text text-muted">
                      選擇性設定：指定從哪個等級降等而來，不選擇則代表任何等級降等都觸發
                    </small>
                  </b-form-group>
                  <b-form-group
                    label-cols="12"
                    label-cols-lg="3"
                    label-size="sm"
                    label="目標等級"
                  >
                    <b-form-select
                      v-model="levelCondition.to_customer_level_id"
                      :options="toLevelOptions"
                      :disabled="isReadOnly || isFetchCustomerLevels"
                    ></b-form-select>
                    <small class="form-text text-muted">
                      選擇性設定：指定降等到哪個等級時觸發，選擇「無等級」代表降等到沒有會員等級
                    </small>
                  </b-form-group>
                </template>

                <!--打卡-->
                <template v-else-if="form.trigger.type == 'checkin'">
                  <div class="form-inline mb-2">
                    連續
                    <b-form-input
                      v-model.number="form.trigger['continuous']"
                      class="w-auto mx-2"
                      type="number"
                      size="sm"
                      min="1"
                      :state="
                        v$.form.trigger['continuous'] &&
                        v$.form.trigger['continuous'].$error
                          ? false
                          : null
                      "
                    />
                    天
                  </div>
                </template>
                <!--登入-->
                <template v-else-if="form.trigger.type == 'login'">
                  <div class="form-inline mb-2">
                    <b-form-input
                      v-model.number="form.trigger['frequency']"
                      class="w-auto mx-2"
                      type="number"
                      size="sm"
                      min="1"
                      :state="
                        v$.form.trigger['frequency'] &&
                        v$.form.trigger['frequency'].$error
                          ? false
                          : null
                      "
                    />
                    次
                  </div>
                </template>
                <!--特殊時段登入-->
                <template v-else-if="form.trigger.type == 'special-login'">
                  <div class="form-inline mb-2 d-flex flex-nowrap">
                    <b-form-radio
                      v-model="form.trigger.value"
                      value="dateRange"
                      @change="
                        () => {
                          form.trigger = {
                            type: form.trigger.type,
                            value: 'dateRange',
                            dateRange: {
                              from: new Date(),
                              to: new Date(),
                            },
                            timeRange: {
                              from: { HH: null, mm: null },
                              to: { HH: null, mm: null },
                            },
                          };
                        }
                      "
                    ></b-form-radio>
                    <div>
                      <div
                        class="
                          d-flex
                          flex-column flex-xl-row
                          align-items-start align-items-xl-center
                        "
                      >
                        <datepicker
                          placeholder="選擇日期"
                          v-model="form.trigger.dateRange.from"
                          bootstrap-styling
                          format="yyyy-MM-dd"
                          :language="zh"
                          clear-button
                          :disabled="form.trigger.value != 'dateRange'"
                          :disabledDates="disabledDates"
                          :input-class="
                            v$.form.trigger['dateRange'].from &&
                            v$.form.trigger['dateRange'].from.$error
                              ? 'is-invalid'
                              : ''
                          "
                        ></datepicker>
                        <span class="mx-2">~</span>
                        <datepicker
                          placeholder="選擇日期"
                          v-model="form.trigger.dateRange.to"
                          bootstrap-styling
                          format="yyyy-MM-dd"
                          :language="zh"
                          clear-button
                          :disabled="form.trigger.value != 'dateRange'"
                          :disabledDates="disabledDates"
                          :input-class="
                            v$.form.trigger['dateRange'].to &&
                            v$.form.trigger['dateRange'].to.$error
                              ? 'is-invalid'
                              : ''
                          "
                        ></datepicker>
                      </div>
                      <b-form-invalid-feedback
                        class="w-100"
                        :state="
                          v$.form.trigger['dateRange'].beforeEndAt &&
                          !v$.form.trigger.dateRange.beforeEndAt.$invalid
                        "
                      >
                        結束時間必須大於起始時間
                      </b-form-invalid-feedback>
                    </div>
                  </div>

                  <div class="form-inline mb-2 d-flex flex-nowrap">
                    <b-form-radio
                      v-model="form.trigger.value"
                      value="timeRange"
                      @change="
                        () => {
                          form.trigger = {
                            type: form.trigger.type,
                            value: 'timeRange',
                            dateRange: {
                              from: new Date(),
                              to: new Date(),
                            },
                            timeRange: {
                              from: { HH: null, mm: null },
                              to: { HH: null, mm: null },
                            },
                          };
                        }
                      "
                    ></b-form-radio>
                    <div>
                      <div
                        class="
                          d-flex
                          flex-column flex-xl-row
                          align-items-start align-items-xl-center
                        "
                      >
                        <vue-timepicker
                          placeholder="選擇時間"
                          v-model="form.trigger.timeRange.from"
                          :disabled="form.trigger.value != 'timeRange'"
                          :input-class="[
                            'form-control',
                            v$.form.trigger['timeRange'].from &&
                            (v$.form.trigger['timeRange'].from.HH.$error ||
                              v$.form.trigger['timeRange'].from.mm.$error)
                              ? 'is-invalid'
                              : '',
                          ]"
                        ></vue-timepicker>
                        <span class="mx-2">~</span>
                        <vue-timepicker
                          placeholder="選擇時間"
                          v-model="form.trigger.timeRange.to"
                          :disabled="form.trigger.value != 'timeRange'"
                          :input-class="[
                            'form-control',
                            v$.form.trigger['timeRange'].to &&
                            (v$.form.trigger['timeRange'].to.HH.$error ||
                              v$.form.trigger['timeRange'].to.mm.$error)
                              ? 'is-invalid'
                              : '',
                          ]"
                        ></vue-timepicker>
                      </div>
                      <b-form-invalid-feedback
                        class="w-100"
                        :state="
                          v$.form.trigger.timeRange.beforeEndAt &&
                          !v$.form.trigger.timeRange.beforeEndAt.$invalid
                        "
                      >
                        結束時間必須大於起始時間
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </template>

                <!--單筆訂單 & 單月購買 & 期間購買-->
                <template
                  v-if="
                    ['purchase', 'month-purchase', 'range-purchase'].includes(
                      form.trigger.type
                    )
                  "
                >
                  <div class="form-inline mb-2">
                    <div
                      v-if="form.trigger.type == 'range-purchase'"
                      class="
                        d-flex
                        flex-column flex-xl-row
                        align-items-start align-items-xl-center
                      "
                    >
                      <datepicker
                        placeholder="選擇日期"
                        v-model="form.trigger.from"
                        bootstrap-styling
                        format="yyyy-MM-dd"
                        :language="zh"
                        clear-button
                        :disabledDates="disabledDates"
                        :input-class="
                          v$.form.trigger.from && v$.form.trigger.from.$error
                            ? 'is-invalid'
                            : ''
                        "
                      ></datepicker>
                      <span class="mx-2">~</span>
                      <datepicker
                        placeholder="選擇日期"
                        v-model="form.trigger.to"
                        bootstrap-styling
                        format="yyyy-MM-dd"
                        :language="zh"
                        clear-button
                        :disabledDates="disabledDates"
                        :input-class="
                          v$.form.trigger.to && v$.form.trigger.to.$error
                            ? 'is-invalid'
                            : ''
                        "
                      ></datepicker>
                    </div>
                    <b-form-invalid-feedback
                      class="w-100"
                      :state="
                        v$.form.trigger.from.beforeEndAt &&
                        !v$.form.trigger.from.beforeEndAt.$invalid
                      "
                    >
                      結束時間必須大於起始時間
                    </b-form-invalid-feedback>
                  </div>

                  <div class="form-inline mb-2">
                    <b-form-radio
                      v-model="form.trigger.value"
                      value="frequency"
                      @change="
                        () => {
                          let v = {
                            type: form.trigger.type,
                            value: 'frequency',
                            frequency: 1,
                          };

                          if (v.type == 'range-purchase') {
                            v.from = form.trigger.from;
                            v.to = form.trigger.to;
                          }

                          form.trigger = v;
                        }
                      "
                    ></b-form-radio>
                    <b-form-input
                      v-model.number="form.trigger['frequency']"
                      class="w-auto mx-2"
                      type="number"
                      size="sm"
                      :disabled="form.trigger.value != 'frequency'"
                      min="1"
                      :state="
                        v$.form.trigger.frequency &&
                        v$.form.trigger.frequency.$error
                          ? false
                          : null
                      "
                    />
                    次
                  </div>

                  <div class="form-inline mb-2">
                    <b-form-radio
                      v-model="form.trigger.value"
                      value="item"
                      @change="
                        () => {
                          let v = {
                            type: form.trigger.type,
                            value: 'item',
                            item: 1,
                          };

                          if (v.type == 'range-purchase') {
                            v.from = form.trigger.from;
                            v.to = form.trigger.to;
                          }

                          form.trigger = v;
                        }
                      "
                    ></b-form-radio>
                    <b-form-input
                      v-model.number="form.trigger['item']"
                      class="w-auto mx-2"
                      type="number"
                      size="sm"
                      :disabled="form.trigger.value != 'item'"
                      min="1"
                      :state="
                        v$.form.trigger.item && v$.form.trigger.item.$error
                          ? false
                          : null
                      "
                    />
                    項商品
                  </div>

                  <div class="form-inline mb-2">
                    <b-form-radio
                      v-model="form.trigger.value"
                      value="amount"
                      @change="
                        () => {
                          let v = {
                            type: form.trigger.type,
                            value: 'amount',
                            amount: 1,
                          };

                          if (v.type == 'range-purchase') {
                            v.from = form.trigger.from;
                            v.to = form.trigger.to;
                          }

                          form.trigger = v;
                        }
                      "
                    ></b-form-radio>
                    滿
                    <b-form-input
                      v-model.number="form.trigger['amount']"
                      class="w-auto mx-2"
                      type="number"
                      size="sm"
                      :disabled="form.trigger.value != 'amount'"
                      min="1"
                      :state="
                        v$.form.trigger.amount && v$.form.trigger.amount.$error
                          ? false
                          : null
                      "
                    />
                    金額
                  </div>
                </template>

                <!-- 會員等級篩選條件（目前僅支援 birthday） -->
                <template v-if="form.trigger.type === 'birthday'">
                  <hr class="my-4" />
                  <h5 class="mb-3 font-weight-bold">額外篩選條件</h5>
                  <b-form-group>
                    <b-form-checkbox
                      v-model="enableLevelMatch"
                      :disabled="isReadOnly || isFetchCustomerLevels"
                    >
                      是否判斷會員等級
                    </b-form-checkbox>
                    <small class="form-text text-muted">
                      勾選後，只有符合指定等級的會員才會觸發此事件
                    </small>
                  </b-form-group>

                  <div v-if="enableLevelMatch" class="ml-4 mt-3">
                    <div v-if="isFetchCustomerLevels" class="text-muted">
                      <b-spinner small /> 載入會員等級中...
                    </div>
                    <div v-else-if="customerLevelOptions.length === 0" class="text-muted">
                      尚未設定會員等級
                    </div>
                    <div v-else>
                      <p class="mb-2">請選擇符合條件的會員等級：</p>
                      <b-form-checkbox-group
                        v-model="selectedLevelHashIds"
                        :options="customerLevelOptions.map(level => ({
                          value: level.hashid,
                          text: level.text,
                        }))"
                        stacked
                        :disabled="isReadOnly"
                      ></b-form-checkbox-group>
                    </div>
                  </div>
                </template>

                <div
                  class="d-flex justify-content-center"
                  style="margin-top: 100px"
                >
                  <b-button
                    class="mr-3"
                    variant="outline-danger"
                    @click="goListPage"
                    >返回
                  </b-button>
                  <b-button
                    v-if="!isReadOnly"
                    @click="handleSubmit"
                    variant="success"
                    >儲存</b-button
                  >
                </div>
              </div>
            </section>

            <!-- 執行事件內容 -->
            <section class="mb-5" v-if="step == '#event'">
              <h4 class="mb-2 font-weight-bold">執行事件內容</h4>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="sm"
                label="貼標"
              >
                <div class="border rounded p-1">
                  <b-badge
                    v-for="(tag, idx) in form.response.tags"
                    :key="idx"
                    variant="dark"
                    class="m-1"
                  >
                    {{ tag }}
                    <button
                      class="btn btn-xs p-0"
                      @click="form.response.tags.splice(idx, 1)"
                    >
                      <i class="fa fa-remove text-white" />
                    </button>
                  </b-badge>
                  <b-input
                    type="text"
                    class="border-0"
                    maxlength="40"
                    placeholder="輸入標籤"
                    @keyup="
                      (e) => {
                        let v = null;

                        if (e.key == ',') {
                          v = e.target.value.slice(0, -1);
                        } else if (e.key == 'Enter') {
                          v = e.target.value;
                        }

                        if (v && !form.response.tags.includes(v)) {
                          form.response.tags.push(v);
                          e.target.value = '';
                        }
                      }
                    "
                  />
                </div>
              </b-form-group>

              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="sm"
                label="發放優惠卷"
              >
                <div class="d-flex align-items-center mb-2">
                  <b-button
                    class="ml-0 btn-inverse-primary"
                    :disabled="showLoading|| isFetchCoupon"
                    v-b-modal.modal-search-coupon
                  >
                    選擇優惠券
                  </b-button>
                  <div v-if="showLoading || isFetchCoupon" class="ml-2">
                    <b-spinner variant="secondary" small />
                  </div>
                </div>
                <div>
                  <b-card
                    v-for="(coupon, idx) in selectedCoupons"
                    :key="coupon.id"
                    class="mb-3"
                    no-body
                  >
                    <b-card-header class="d-flex justify-content-between align-items-center py-2">
                      <span class="font-weight-bold">{{ coupon.name }}</span>
                      <b-button
                        variant="link"
                        class="text-danger p-0"
                        @click="handleUpdateCoupon(coupon)"
                      >
                        <i class="mdi mdi-close mdi-18px"></i>
                      </b-button>
                    </b-card-header>
                    <b-card-body class="py-2">
                      <b-form-checkbox
                        v-model="selectedCoupons[idx].is_push_line"
                        class="mb-2"
                        :disabled="isReadOnly"
                      >
                        推播 LINE 通知
                      </b-form-checkbox>
                      <b-form-checkbox
                        v-model="selectedCoupons[idx].repeat_assign"
                        :disabled="isReadOnly"
                      >
                        允許重複發放
                      </b-form-checkbox>
                    </b-card-body>
                  </b-card>
                </div>
                <!-- <b-form-checkbox
                  v-model="form.response.coupon.limite"
                >
                  每人限定一張
                </b-form-checkbox> -->
              </b-form-group>
              <AutoMarketingSearchCoupon :selectedCoupons="selectedCoupons" @submit="handleSubmitCoupon" />

              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="sm"
                label="發放徽章"
              >
                <b-form-select
                  class="mb-2"
                  disabled
                  v-model="form.response.badge.id"
                ></b-form-select>
              </b-form-group>

              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="sm"
                label="發放點數"
              >
                <div v-if="!isEnablePoint" key="point-disabled-view">
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    @click="isEnablePoint = true"
                  >
                    <i class="mdi mdi-plus mr-1"></i>新增點數發放
                  </b-button>
                </div>

                <b-card v-if="isEnablePoint" key="point-enabled-view" class="mb-3 border-secondary shadow-sm" no-body>
                  <b-card-header
                    class="d-flex justify-content-between align-items-center py-2 bg-light"
                  >
                    <span class="font-weight-bold">點數發放設定</span>
                    <b-button
                      variant="link"
                      class="text-danger p-0"
                      @click="handleDisablePoint"
                      v-b-tooltip.hover
                      title="取消點數發放"
                    >
                      <i class="mdi mdi-close-circle mdi-24px"></i>
                    </b-button>
                  </b-card-header>
                  <b-card-body class="p-4">
                    <!-- 第一部分：發放規則 -->
                    <div class="mb-4">
                      <!-- 點數發放名稱 -->
                      <div class="d-flex align-items-center mb-3">
                        <h6 class="mb-0 font-weight-bold">點數發放名稱</h6>
                      </div>

                      <div class="pl-4 mb-4">
                        <b-form-input
                          id="point-name-input"
                          v-model="form.response.point.name"
                          type="text"
                          placeholder="請輸入點數發放名稱"
                          size="sm"
                          :disabled="isReadOnly"
                          maxlength="100"
                        />
                      </div>

                      <div class="d-flex align-items-center mb-3">
                        <h6 class="mb-0 font-weight-bold">發放方式與數值</h6>
                      </div>

                      <div class="pl-4">
                        <div class="bg-white rounded border overflow-hidden">
                          <!-- 主要數值設定 -->
                          <div
                            class="d-flex align-items-center p-3 border-bottom"
                          >
                            <b-form-radio
                              v-model="form.response.point.type"
                              value="fixed"
                              class="m-0 mr-2"
                            ></b-form-radio>
                            <span class="mr-3">固定發放</span>
                            <b-form-input
                              v-model.number="form.response.point.point"
                              type="number"
                              size="sm"
                              min="1"
                              style="width: 100px"
                              class="mx-2"
                            ></b-form-input>
                            <span>點</span>
                          </div>

                          <!-- 次要發送邏輯設定 (整合至此) -->
                          <div class="px-3 py-2 bg-light">
                            <b-form-checkbox
                              v-model="form.response.point.allow_repeat"
                              size="sm"
                              class="m-0"
                            >
                              <span class="text-dark">允許重複發送</span>
                            </b-form-checkbox>
                            <div
                              class="text-muted mt-1 ml-4"
                              style="font-size: 0.8rem"
                            >
                              <i class="mdi mdi-information-outline"></i>
                              勾選後，符合條件時可重複領取（例如：每年生日皆能再次獲取點數）。
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr class="my-4 border-light" />

                    <!-- 第二部分：過期設定 -->
                    <div>
                      <div class="d-flex align-items-center mb-3">
                        <h6 class="mb-0 font-weight-bold">點數過期規則</h6>
                      </div>

                      <div class="pl-4">
                        <!-- 無期限 -->
                        <div
                          class="mb-3 p-3 rounded border"
                          :class="
                            form.response.point.expiration.type === 'none'
                              ? 'border-primary bg-white'
                              : 'bg-light'
                          "
                        >
                          <b-form-radio
                            v-model="form.response.point.expiration.type"
                            value="none"
                          >
                            <span
                              :class="
                                form.response.point.expiration.type === 'none'
                                  ? 'font-weight-bold text-primary'
                                  : ''
                              "
                              >永久有效 (無期限)</span
                            >
                          </b-form-radio>
                        </div>
                        <!-- 相對時間 -->
                        <div
                          class="mb-3 p-3 rounded border"
                          :class="
                            form.response.point.expiration.type ===
                            'shifted_date'
                              ? 'border-primary bg-white'
                              : 'bg-light'
                          "
                        >
                          <b-form-radio
                            v-model="form.response.point.expiration.type"
                            value="shifted_date"
                            class="mb-2"
                          >
                            <span
                              :class="
                                form.response.point.expiration.type ===
                                'shifted_date'
                                  ? 'font-weight-bold text-primary'
                                  : ''
                              "
                              >依相對時間過期</span
                            >
                          </b-form-radio>
                          <div
                            class="d-flex align-items-center ml-4"
                            v-if="
                              form.response.point.expiration.type ===
                              'shifted_date'
                            "
                          >
                            <span class="mr-2">發放後</span>
                            <b-form-input
                              v-model.number="
                                form.response.point.expiration.number
                              "
                              type="number"
                              size="sm"
                              style="width: 80px"
                              class="mx-1"
                            ></b-form-input>
                            <b-form-select
                              v-model="form.response.point.expiration.unit"
                              :options="expirationUnitOptions"
                              size="sm"
                              style="width: 100px"
                              class="mx-1"
                            ></b-form-select>
                            <span>自動失效</span>
                          </div>
                        </div>

                        <!-- 特定日期 -->
                        <div
                          class="mb-3 p-3 rounded border"
                          :class="
                            form.response.point.expiration.type === 'fixed_date'
                              ? 'border-primary bg-white'
                              : 'bg-light'
                          "
                        >
                          <b-form-radio
                            v-model="form.response.point.expiration.type"
                            value="fixed_date"
                            class="mb-2"
                          >
                            <span
                              :class="
                                form.response.point.expiration.type ===
                                'fixed_date'
                                  ? 'font-weight-bold text-primary'
                                  : ''
                              "
                              >依特定日期過期 (年度週期)</span
                            >
                            <i
                              class="fa fa-question-circle ml-1 text-muted"
                              style="cursor: pointer;"
                              title="點擊，觀看設定說明"
                              @click.stop="showFixedDateModal = true"
                            ></i>
                          </b-form-radio>

                          <div
                            v-if="
                              form.response.point.expiration.type ===
                              'fixed_date'
                            "
                            class="ml-4"
                          >
                            <!-- 週期定義 -->
                            <div
                              class="
                                d-flex
                                align-items-center
                                mb-3
                                p-2
                                bg-light
                                rounded-sm
                                border
                              "
                            >
                              <i
                                class="mdi mdi-calendar-range mr-2 text-primary"
                              ></i>
                              <span class="mr-1">年度週期：</span>
                              <b-form-select
                                v-model="
                                  form.response.point.expiration
                                    .period_start_month
                                "
                                :options="monthOptions"
                                size="sm"
                                class="mx-1 w-auto"
                              ></b-form-select>
                              月
                              <b-form-select
                                v-model="
                                  form.response.point.expiration
                                    .period_start_day
                                "
                                :options="
                                  dayOptions(
                                    form.response.point.expiration
                                      .period_start_month
                                  )
                                "
                                size="sm"
                                class="mx-1 w-auto"
                              ></b-form-select>
                              日
                              <span class="mx-2">至</span>
                              <span class="text-primary"
                                >{{
                                  form.response.point.expiration
                                    .period_end_month
                                }}
                                月
                                {{
                                  form.response.point.expiration.period_end_day
                                }}
                                日</span
                              >
                            </div>

                            <!-- 過期點定義 -->
                            <div
                              class="d-flex align-items-center flex-wrap mt-2"
                              style="line-height: 2"
                            >
                              <span>點數將於</span>
                              <span class="mx-1 text-primary"
                                >{{
                                  form.response.point.expiration
                                    .period_end_month
                                }}
                                月
                                {{
                                  form.response.point.expiration.period_end_day
                                }}
                                日</span
                              >
                              <span>結算，並在</span>
                              <b-form-input
                                v-model.number="
                                  form.response.point.expiration
                                    .expiry_offset_years
                                "
                                type="number"
                                size="sm"
                                style="width: 70px"
                                class="mx-1 text-center"
                              ></b-form-input>
                              <span class="mr-2">年後的</span>
                              <b-form-select
                                v-model="
                                  form.response.point.expiration.expiry_month
                                "
                                :options="expiryMonthOptions"
                                size="sm"
                                style="width: 80px"
                                class="mx-1"
                              ></b-form-select>
                              月
                              <b-form-select
                                v-model="
                                  form.response.point.expiration.expiry_day
                                "
                                :options="expiryDayOptions"
                                size="sm"
                                style="width: 80px"
                                class="mx-1"
                              ></b-form-select>
                              日
                              <span class="ml-1 text-danger">正式失效</span>
                            </div>

                            <div
                              v-if="fixedDatePreview"
                              class="mt-2"
                            >
                              <div
                                class="d-flex align-items-center"
                                style="cursor: pointer; font-size: 0.875rem; color: #28a745;"
                                @click="showFixedDatePreview = !showFixedDatePreview"
                              >
                                <i :class="showFixedDatePreview ? 'fa fa-chevron-down' : 'fa fa-chevron-right'" class="mr-1"></i>
                                預覽試算
                              </div>
                              <div
                                v-if="showFixedDatePreview"
                                class="mt-1 p-2 rounded border border-success"
                                style="font-size: 0.875rem; color: #28a745; background-color: #f0fff4;"
                              >
                                若您在 今日: <strong>{{ fixedDatePreview.todayStr }}</strong> 發放點數，<br>
                                該點數將歸屬於 <strong>{{ fixedDatePreview.cycleStartStr }} ~ {{ fixedDatePreview.cycleEndStr }}</strong> 週期，並於 <strong>{{ fixedDatePreview.expiryStr }}</strong> 到期。
                              </div>
                            </div>
                          </div>
                        </div>

                        <b-modal
                          v-model="showFixedDateModal"
                          title="點數(依特定日期) 說明"
                          ok-only
                          ok-title="關閉"
                          dialog-class="modal-half"
                        >
                          <p>系統將依據您設定的「年度週期」歸納點數，同一週期內獲得的點數，將統一於指定的延長年份日期失效。</p>
                          <p><strong>舉例情境：</strong>若設定週期為 1/10 至 隔年1/9，並於 1 年後的 12/31 失效。若會員在 2026/01/30 獲得點數（屬於2026/01/10 ~ 2027/01/09 週期），該筆點數將於 2028/12/31 正式失效。</p>
                        </b-modal>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>

              </b-form-group>

              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="sm"
                label="發送推播"
              >
              </b-form-group>

              <div
                class="d-flex justify-content-center"
                style="margin-top: 100px"
              >
                <b-button
                  class="mr-3"
                  variant="outline-danger"
                  @click="goListPage"
                  >返回
                </b-button>
                <b-button
                  v-if="!isReadOnly"
                  @click="handleSubmit"
                  variant="success"
                  >儲存</b-button
                >
              </div>
            </section>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, minValue } from "@vuelidate/validators";
import { isBefore, set, subDays } from "date-fns";
import Datepicker from "vuejs-datepicker";
import { zh } from "vuejs-datepicker/dist/locale";
import _ from "lodash";
import moment from "moment";
import autoMarketingApi from "@/apis/auto-marketing";
import redeemCodeBundleApi from "@/apis/redeemCodeBundle";
import merchantApi from "@/apis/merchant";
import customerLevelApi from "@/apis/customer-levels";
import AutoMarketingSearchCoupon from "./AutoMarketingSearchCoupon.vue";
import * as consts from "@/consts";
import { replaceHash } from "@/utils/UrlMutater";

const triggers = [
  {
    value: "birthday",
    text: "生日事件",
    options: [
      {
        text: "每天",
        value: "day",
      },
      {
        text: "每週",
        value: "week",
      },
      {
        text: "每月",
        value: "month",
      },
    ],
    default: {
      type: "birthday",
      value: "day",
    },
  },
  {
    value: "line_follow",
    text: "好友事件",
    default: {
      type: "line_follow",
    },
  },
  {
    value: "registered",
    text: "註冊事件",
    default: {
      type: "registered",
    },
  },
  {
    value: "checkin",
    text: "打卡",
    options: ["continuous"],
    default: {
      type: "checkin",
      continuous: 1,
      value: "continuous",
    },
  },
  {
    value: "login",
    text: "登入",
    options: ["frequency"],
    default: {
      type: "login",
      value: "frequency",
      frequency: 1,
    },
  },
  {
    value: "special-login",
    text: "特殊時段登入",
    options: ["dateRange", "timeRange"],
    default: {
      type: "special-login",
      value: "dateRange",
      dateRange: { from: new Date(), to: new Date() },
      timeRange: { from: { HH: null, mm: null }, to: { HH: null, mm: null } },
    },
  },
  {
    value: "purchase",
    text: "單筆訂單",
    options: ["frequency", "item", "amount"],
    default: {
      type: "purchase",
      value: "frequency",
      frequency: 1,
    },
  },
  {
    value: "month-purchase",
    text: "單月購買",
    options: ["frequency", "item", "amount"],
    default: {
      type: "month-purchase",
      value: "frequency",
      frequency: 1,
    },
  },
  {
    value: "range-purchase",
    text: "期間購買",
    options: ["frequency", "item", "amount"],
    default: {
      type: "range-purchase",
      value: "frequency",
      from: new Date(),
      to: new Date(),
      frequency: 1,
    },
  },
  {
    value: "customer_upgraded",
    text: "升等",
    default: {
      type: "customer_upgraded",
    },
  },
  {
    value: "customer_extended",
    text: "續等",
    default: {
      type: "customer_extended",
    },
  },
  {
    value: "customer_downgraded",
    text: "降等",
    default: {
      type: "customer_downgraded",
    },
  },
];

export default {
  components: { Datepicker, AutoMarketingSearchCoupon },
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    let trigger = {
      type: { required },
    };

    //Trigger 打卡
    trigger["continuous"] =
      this.form.trigger.type == "checkin" &&
      this.form.trigger.value == "continuous"
        ? { required, minValue: minValue(1) }
        : {};

    //Trigger 登入
    trigger["frequency"] =
      this.form.trigger.type == "login" &&
      this.form.trigger.value == "frequency"
        ? { required, minValue: minValue(1) }
        : {};

    //Trigger 特殊時段登入
    trigger["dateRange"] =
      this.form.trigger.type == "special-login" &&
      this.form.trigger.value == "dateRange"
        ? {
            from: { required },
            to: { required },
            beforeEndAt: () => {
              if (
                !this.form.trigger.dateRange.from ||
                !this.form.trigger.dateRange.to
              ) {
                return true;
              }

              const startDate = set(
                new Date(this.form.trigger.dateRange.from),
                {
                  hours: 0,
                  minutes: 0,
                }
              );
              const endDate = set(new Date(this.form.trigger.dateRange.to), {
                hours: 23,
                minutes: 59,
              });
              return isBefore(startDate, endDate);
            },
          }
        : {};

    trigger["timeRange"] =
      this.form.trigger.type == "special-login" &&
      this.form.trigger.value == "timeRange"
        ? {
            from: { HH: { required }, mm: { required } },
            to: { HH: { required }, mm: { required } },
            beforeEndAt: () => {
              if (
                !this.form.trigger.timeRange.from ||
                !this.form.trigger.timeRange.to
              ) {
                return true;
              }

              const startDate = set(new Date(), {
                hours: this.form.trigger.timeRange.from.HH,
                minutes: this.form.trigger.timeRange.from.mm,
              });
              const endDate = set(new Date(), {
                hours: this.form.trigger.timeRange.to.HH,
                minutes: this.form.trigger.timeRange.to.mm,
              });
              return isBefore(startDate, endDate);
            },
          }
        : {};

    //Trigger 單筆訂單 & 單月購買 & 期間購買
    trigger["frequency"] =
      ["purchase", "month-purchase", "range-purchase"].includes(
        this.form.trigger.type
      ) && this.form.trigger.value == "frequency"
        ? { required, minValue: minValue(1) }
        : {};

    trigger["item"] =
      ["purchase", "month-purchase", "range-purchase"].includes(
        this.form.trigger.type
      ) && this.form.trigger.value == "item"
        ? { required, minValue: minValue(1) }
        : {};

    trigger["amount"] =
      ["purchase", "month-purchase", "range-purchase"].includes(
        this.form.trigger.type
      ) && this.form.trigger.value == "amount"
        ? { required, minValue: minValue(1) }
        : {};

    //Trigger 期間購買
    trigger["from"] =
      this.form.trigger.type == "range-purchase"
        ? {
            required,
            beforeEndAt: () => {
              if (!this.form.trigger.from || !this.form.trigger.to) {
                return true;
              }

              const startDate = set(new Date(this.form.trigger.from), {
                hours: 0,
                minutes: 0,
              });
              const endDate = set(new Date(this.form.trigger.to), {
                hours: 23,
                minutes: 59,
              });
              return isBefore(startDate, endDate);
            },
          }
        : {};
    trigger["to"] =
      this.form.trigger.type == "range-purchase" ? { required } : {};

    //Response
    let response = {
      point: {},
    };

    //Response 發放點數
    response.point["point"] =
      this.isEnablePoint && this.form.response.point.type == "fixed"
        ? { required, minValue: minValue(1) }
        : {};

    response.point["multiple"] =
      this.isEnablePoint && this.form.response.point.type == "multiple"
        ? { required, minValue: minValue(1) }
        : {};

    response.point["levelAmount"] =
      this.isEnablePoint && this.form.response.point.type == "level"
        ? { required, minValue: minValue(1) }
        : {};

    response.point["levelPoint"] =
      this.isEnablePoint && this.form.response.point.type == "level"
        ? { required, minValue: minValue(1) }
        : {};

    let validation = {
      form: {
        title: { required },
        start_at: {
          required,
          beforeEndAt: () => {
            if (!this.form.start_at || !this.form.end_at) {
              return true;
            }

            const startDate = set(new Date(this.form.start_at), {
              hours: 0,
              minutes: 0,
            });
            const endDate = set(new Date(this.form.end_at), {
              hours: 23,
              minutes: 59,
            });
            return isBefore(startDate, endDate);
          },
        },
        end_at: { required },
        type: { required },
        is_enabled: { required },
        config: { required },
        merchant_id: { required },
        trigger,
        response,
      },
    };
    return validation;
  },

  data() {
    return {
      zh,
      showLoading: false,
      isEditing: false,
      validationErrors: null,
      disabledDates: { to: subDays(new Date(), 1) },
      step: "",
      form: {
        title: null,
        start_at: new Date(),
        end_at: new Date(),
        type: null,
        is_enabled: true,
        config: null,
        merchant_id: null,
        trigger: {
          type: "",
          value: "",
        },
        response: {
          tags: [],
          coupon: [],
          badge: { id: null },
          point: {
            name: null,
            type: "fixed",
            point: null,
            allow_repeat: false,
            expiration: {
              type: "none",
              unit: "day",
              number: 1,
              period_start_month: 1,
              period_start_day: 1,
              period_end_month: 12,
              period_end_day: 31,
              expiry_offset_years: 1,
              expiry_month: 12,
              expiry_day: 31,
            },
          },
        },
      },
      merchants: [],
      isFetchMerchants: false,
      selectedCoupons: [],
      isFetchCoupon: false,
      // 會員等級相關
      customerLevelOptions: [],
      isFetchCustomerLevels: false,
      levelCondition: {
        from_customer_level_id: null,
        to_customer_level_id: null,
        customer_level_id: null,
      },
      // 會員等級篩選條件（level_match）
      enableLevelMatch: false,
      selectedLevelHashIds: [],
      isEnablePoint: false,
      showFixedDateModal: false,
      showFixedDatePreview: false,
    };
  },

  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    ...mapGetters("route", ["from", "routeQuery"]),

    fixedDatePreview() {
      const exp = this.form.response.point.expiration;
      const { period_start_month, period_start_day, period_end_month, period_end_day, expiry_offset_years, expiry_month, expiry_day } = exp;
      if (!period_start_month || !period_start_day || !period_end_month || !period_end_day || !expiry_month || !expiry_day) {
        return null;
      }
      const today = new Date();
      const periodStartThisYear = new Date(today.getFullYear(), period_start_month - 1, period_start_day);
      const cycleStartYear = today >= periodStartThisYear ? today.getFullYear() : today.getFullYear() - 1;
      const crossesYear = period_start_month > period_end_month ||
        (period_start_month === period_end_month && period_start_day > period_end_day);
      const cycleEndYear = crossesYear ? cycleStartYear + 1 : cycleStartYear;
      const expiryYear = cycleEndYear + Number(expiry_offset_years);
      const fmt = (y, m, d) => `${y}/${String(m).padStart(2, '0')}/${String(d).padStart(2, '0')}`;
      return {
        todayStr: fmt(today.getFullYear(), today.getMonth() + 1, today.getDate()),
        cycleStartStr: fmt(cycleStartYear, period_start_month, period_start_day),
        cycleEndStr: fmt(cycleEndYear, period_end_month, period_end_day),
        expiryStr: fmt(expiryYear, expiry_month, expiry_day),
      };
    },

    isReadOnly() {
      return this.$route.name === "AutoMarketingView";
    },
    isEdit() {
      return this.$route.name === "AutoMarketingEdit";
    },
    type() {
      if (this.isEdit) {
        return this.form.type;
      }
      return this.$route.params.type;
    },
    title() {
      return triggers.find(({ value }) => value === this.type)?.text ?? "";
    },
    isCustomerLevelEvent() {
      return ["customer_upgraded", "customer_downgraded", "customer_extended"].includes(this.type);
    },
    // 來源等級選項（包含「任何等級」選項）
    fromLevelOptions() {
      if (this.type === "customer_upgraded") {
        return [
        { value: null, text: "任何等級" },
        ...this.customerLevelOptions.slice(0,-1),
        ];
      }
      return [
        { value: null, text: "任何等級" },
        ...this.customerLevelOptions,
      ];
    },
    // 目標等級選項（包含「任何等級」或「無等級」選項，根據事件類型）
    toLevelOptions() {
      if (this.type === "customer_upgraded" && this.levelCondition.from_customer_level_id) {
        const fromLevel = this.customerLevelOptions.findIndex(level => level.value === this.levelCondition.from_customer_level_id);
        return this.customerLevelOptions.slice(fromLevel+1);
      }
      else if (this.type === "customer_downgraded") {
        if (this.levelCondition.from_customer_level_id) {
          const fromLevel = this.customerLevelOptions.findIndex(level => level.value === this.levelCondition.from_customer_level_id);
          return [
            { value: null, text: "無等級" },
            ...this.customerLevelOptions.slice(0,fromLevel)
          ];
        }
        return [
          { value: null, text: "無等級" },
          ...this.customerLevelOptions,
        ];
      }
      return [
        { value: null, text: "任何等級" },
        ...this.customerLevelOptions,
      ];
    },
    // 續等專用的等級選項
    extendLevelOptions() {
      return [{ value: null, text: "任何等級" }, ...this.customerLevelOptions];
    },

    // 過期時間相關選項
    monthOptions() {
      return Array.from({ length: 12 }, (_, i) => ({
        value: i + 1,
        text: i + 1,
      }));
    },
    computedPeriodEnd() {
      const expiration = this.form.response.point.expiration;
      const startMonth = expiration.period_start_month;
      const startDay = expiration.period_start_day;

      if (!startMonth || !startDay) return { month: null, day: null };

      const currentYear = new Date().getFullYear();
      const date = new Date(currentYear, startMonth - 1, startDay);
      date.setDate(date.getDate() - 1);

      return {
        month: date.getMonth() + 1,
        day: date.getDate(),
      };
    },
    expiryMonthOptions() {
      const expiration = this.form.response.point.expiration;
      const offsetYears = expiration.expiry_offset_years;

      if (offsetYears !== 0) {
        return this.monthOptions;
      }

      const periodEndMonth = expiration.period_end_month;
      return this.monthOptions.filter((option) => option.value >= periodEndMonth);
    },
    expiryDayOptions() {
      const expiration = this.form.response.point.expiration;
      const month = expiration.expiry_month;
      const offsetYears = expiration.expiry_offset_years;

      if (!month) return [];

      const currentYear = new Date().getFullYear();
      const targetYear = currentYear + Number(offsetYears);
      const daysInMonth = new Date(targetYear, month, 0).getDate();
      const days = Array.from({ length: daysInMonth }, (_, i) => ({
        value: i + 1,
        text: i + 1,
      }));

      // 當年度的過期日需晚於年度終止日
      if (offsetYears === 0) {
        const periodEndMonth = expiration.period_end_month;
        const periodEndDay = expiration.period_end_day;
        const expiryMonth = expiration.expiry_month;

        if (expiryMonth === periodEndMonth) {
          return days.filter((day) => day.value >= periodEndDay);
        }
      }

      return days;
    },
    expirationUnitOptions: () => [
      { value: "day", text: "天" },
      { value: "month", text: "月" },
      { value: "year", text: "年" },
    ],
  },

  async created() {
    if (this.isEdit || this.isReadOnly) {
      await this.fetchAutoMarketing();
    } else {
      this.triggerChange();
    }

    this.getMerchants();
    this.initSelectedCoupons();

    // 獲取會員等級列表（用於等級事件或 level_match 篩選條件）
    this.getCustomerLevelsList();

    // 初始化過期日期計算
    this.updatePeriodEnd();
  },
  mounted(){
    this.navigateToStepFromCurrentRoute();
  },
  methods: {
    moment,
    navigateToStepFromCurrentRoute() {
      const anchor = this.$route.hash;
      if (anchor) {
        this.goToStep(anchor);
      }
    },
    isObject(object) {
      return _.isObject(object);
    },
    triggerChange() {
      this.form.trigger = triggers.find(
        ({ value }) => value === this.type
      )?.default;
      this.form.type = this.type;
    },
    goListPage() {
      if (this.from && this.from.name) {
        this.$router.push({ name: this.from.name, query: this.routeQuery });
      } else if (["customer_upgraded", "customer_downgraded", "customer_extended"].includes(this.type)) {
        this.$router.push({ name: "AutoMarketingMemberLevelEvent" });
      } else {
        // if no previous route, fallback to the default route
        this.$router.push({ name: "AutoMarketingMemberEvent" });
      }
    },
    async fetchAutoMarketing() {
      this.showLoading = true;

      try {
        const { data } = await autoMarketingApi.getMarketingConfig(
          this.$route.params.config_id
        );
        const {
          id,
          merchant_id,
          title,
          type,
          start_at,
          end_at,
          is_enabled,
          config,
        } = data.data;
        this.form = {
          ...this.form,
        };
        this.form.id = id;
        this.form.merchant_id = merchant_id;
        this.form.title = title;
        this.form.type = type;
        // 設置 trigger（根據 type 找到對應的 trigger 配置）
        this.form.trigger = triggers.find(({ value }) => value === type)?.default || { type: type };
        this.form.start_at = start_at;
        this.form.end_at = end_at;
        this.form.is_enabled = is_enabled;
        this.form.config = config;

        config.actions.forEach((action) => {
          if (action.type === "waltily_tagging") {
            this.form.response.tags = action.tags;
          } else if (action.type === "assign_redeem_code") {
            // if (this.form.response.coupon.id == null) {
            //   this.form.response.coupon.id = [];
            // }
            this.form.response.coupon.push(action);
          } else if (action.type === "add_point") {
            this.isEnablePoint = true;
            this.form.response.point = {
              name: action.name || null,
              type: action.point_type,
              point: action.point,
              allow_repeat: action.allow_repeat ?? false,
              expiration: {
                ...(this.form.response.point.expiration || {}),
                ...(action.expiration || {}),
              },
            };
          }
        });

        // 初始化 form.trigger
        const defaultTrigger = triggers.find((t) => t.value === type);
        if (defaultTrigger) {
          this.form.trigger = _.cloneDeep(defaultTrigger.default);
        }

        // 解析會員等級事件的 conditions

        if (config.conditions && config.conditions.length > 0) {
          config.conditions.forEach((condition) => {
            if (condition.type === "level_upgraded" || condition.type === "level_downgraded") {
              this.levelCondition.from_customer_level_id = condition.from_customer_level_id || null;
              this.levelCondition.to_customer_level_id = condition.to_customer_level_id || null;
            } else if (condition.type === "level_extended") {
              this.levelCondition.customer_level_id = condition.customer_level_id || null;
            } else if (condition.type === "level_match") {
              // 解析 level_match condition
              this.enableLevelMatch = true;
              this.selectedLevelHashIds = condition.customer_level_hash_ids || [];
            } else if (condition.type === "birthday" && condition.timing) {
              // 解析 birthday 事件的 timing
              this.form.trigger.value = condition.timing;
            }
          });
        }

        // 從 conditions 回填 form.trigger（僅新增時執行，編輯時不執行以避免覆蓋正確的 trigger type）
        if (!this.isEdit && config.conditions && config.conditions.length > 0) {
          const condition = config.conditions[0];
          const triggerDefault = triggers.find(({ value }) => value === type)?.default || {};
          this.form.trigger = {
            ...triggerDefault,
            type: condition.type,
            value: condition.timing || triggerDefault.value,
          };
        }
      } catch (e) {
        console.error(e);
      }
      this.showLoading = false;
    },
    async handleSubmit() {
      // const result = await this.v$.$validate();
      // if (!result) return;
      this.form.config = {
        actions: [
          // 標籤
          {
            type: "waltily_tagging",
            tags: this.form.response.tags.map((tag) => tag),
          },
        ],
        conditions: [
          {
            type: this.type,
          },
        ],
      };

      // 選擇優惠券
      if (this.selectedCoupons.length) {
        this.selectedCoupons.forEach(coupon => {
          this.form.config.actions.push(
            {
              type: "assign_redeem_code",
              bundle_id: coupon.redeem_code_bundle_id,
              bundle_hashid: coupon.id,
              name: coupon.name,
              is_push_line: coupon.is_push_line ?? true,
              repeat_assign: coupon.repeat_assign ?? true,
            },
          )
        })
      }

      // 發放點數
      if (this.isEnablePoint && this.form.response.point.type) {
        let action = {
          type: "add_point",
          name: this.form.response.point.name || null,
          point_type: this.form.response.point.type,
          allow_repeat: this.form.response.point.allow_repeat ?? false,
        };

        if (action.point_type === "fixed") {
          action.point = this.form.response.point.point;
        } else if (action.point_type === "multiple") {
          action.multiple = this.form.response.point.multiple;
        } else if (action.point_type === "level") {
          action.levelAmount = this.form.response.point.levelAmount;
          action.levelPoint = this.form.response.point.levelPoint;
        }

        // 只有在有填寫對應點數值時才加入 action
        if (
          action.point ||
          action.multiple ||
          (action.levelAmount && action.levelPoint)
        ) {
          this.form.config.actions.push({
          ...action,
          expiration: { ...this.form.response.point.expiration },
        });
        }
      }

      if (this.type === "birthday") {
        this.form.config.conditions = [
          {
            type: this.type,
            timing: this.form.trigger.value,
          },
        ];
      }

      // 如果啟用了會員等級篩選，加入 level_match condition（目前僅支援 birthday）
      if (this.enableLevelMatch && this.selectedLevelHashIds.length > 0 && this.type === "birthday") {
        this.form.config.conditions.push({
          type: "level_match",
          customer_level_hash_ids: this.selectedLevelHashIds,
        });
      }

      // 會員等級事件 - 設定 conditions 中的等級 ID
      if (this.type === "customer_upgraded") {
        this.form.config.conditions = [
          {
            type: "level_upgraded",
            from_customer_level_id: this.levelCondition.from_customer_level_id,
            to_customer_level_id: this.levelCondition.to_customer_level_id,
          },
        ];
      } else if (this.type === "customer_downgraded") {
        this.form.config.conditions = [
          {
            type: "level_downgraded",
            from_customer_level_id: this.levelCondition.from_customer_level_id,
            to_customer_level_id: this.levelCondition.to_customer_level_id,
          },
        ];
      } else if (this.type === "customer_extended") {
        this.form.config.conditions = [
          {
            type: "level_extended",
            customer_level_id: this.levelCondition.customer_level_id,
          },
        ];
      }

      try {
        const payload = this.form;
        if (this.isEdit) {
          await autoMarketingApi.updateMarketingConfig(payload);
        } else {
          await autoMarketingApi.storeMarketingConfig(payload);
        }
        this.goListPage();
      } catch (e) {
        console.log(e);
      }
    },
    async getCustomerLevelsList() {
      try {
        this.isFetchCustomerLevels = true;
        const { data } = await customerLevelApi.list({ all: true });
        this.customerLevelOptions = data.data.map((item) => ({
          value: item.id,
          text: item.name,
          order: item.order,
          hashid: item.id, // API 回傳的 id 就是 hashid
        }));
      } catch (error) {
        console.error(error);
      } finally {
        this.isFetchCustomerLevels = false;
      }
    },
    async getMerchants() {
      this.isFetchMerchants = true;
      const { data } = await merchantApi.list();
      this.isFetchMerchants = false;

      this.merchants = [
        { value: null, text: "請選擇" },
        ...data.data.map((merchant) => {
          return {
            value: merchant.id,
            text: merchant.type_name
              ? `${merchant.name} (${merchant.type_name})`
              : merchant.name,
          };
        }),
      ];

      const lineMerchant = data.data.filter((merchant) => {
        return merchant.type === consts.MERCHANT_TYPES.LINE_TYPE;
      });

      if (lineMerchant && !this.form.merchant_id) {
        this.form.merchant_id = lineMerchant[0].id;
      }
    },

    async initSelectedCoupons() {
      try {
        this.isFetchCoupon = true;

        const couponActions = this.form.response.coupon ?? [];
        const res = await Promise.all(
          couponActions.map((coupon) => {
            return redeemCodeBundleApi.getRedeemCodeBundle(coupon.bundle_hashid);
          })
        );

        this.selectedCoupons = res.map(({ data: { data } }, index) => ({
          ...data,
          is_push_line: couponActions[index]?.is_push_line ?? true,
          repeat_assign: couponActions[index]?.repeat_assign ?? true,
        }));
      } catch (e) {
        console.log(e);
      }
      this.isFetchCoupon = false;
    },
    handleUpdateCoupon(coupon) {
      const index = this.selectedCoupons.findIndex(({ id }) => id === coupon.id);

        if (index === -1) {
          this.selectedCoupons.push(coupon);
        } else {
          this.selectedCoupons.splice(index, 1);
        }
    },
    handleSubmitCoupon(coupons) {
      this.selectedCoupons = coupons.map(coupon => ({
        ...coupon,
        is_push_line: coupon.is_push_line ?? true,
        repeat_assign: coupon.repeat_assign ?? true,
      }));
    },
    handleDisablePoint() {
      this.$swal.fire({
        title: '確定要取消點數發放嗎？',
        text: '取消後，目前設定的點數發放內容將會被移除。',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定取消',
        cancelButtonText: '放棄',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
      }).then((result) => {
        // 兼容舊版與新版 SweetAlert2 的回傳格式
        if (result.isConfirmed || result.value) {
          this.isEnablePoint = false;
          
          this.$nextTick(() => {
            this.form.response.point = {
              type: "fixed",
              point: null,
              allow_repeat: false,
              expiration: {
                type: "none",
                unit: "day",
                number: 1,
                period_start_month: 1,
                period_start_day: 1,
                period_end_month: 12,
                period_end_day: 31,
                expiry_offset_years: 1,
                expiry_month: 12,
                expiry_day: 31,
              },
            };
          });
        }
      });
    },
    goToStep(step) {
      this.step = step;
      replaceHash(step);
    },
    // 共用防止非法鍵
    preventInvalidNumberKey(e, min) {
      const keys = ["-", "+", "e", "E", "."];

      // 阻擋非數字或特殊符號
      if (keys.includes(e.key)) {
        e.preventDefault();
        return;
      }

      // 允許數字，檢查輸入後的值
      const input = e.target;
      const valueAfterKey =
        input.value.substring(0, input.selectionStart) +
        e.key +
        input.value.substring(input.selectionEnd);

      // 如果輸入後的數字小於 min，阻擋按鍵
      if (Number(valueAfterKey) < min) {
        e.preventDefault();
      }
    },
    // 共用輸入修正 method
    onPositiveIntInput(value, path, min) {
      let num = parseInt(value, 10);

      if (!Number.isInteger(num) || num < min) {
        _.set(this, path, min);
        return;
      }

      _.set(this, path, num);
    },
    dayOptions(month) {
      if (!month) return [];

      const currentYear = new Date().getFullYear();
      const daysInMonth = new Date(currentYear, month, 0).getDate();
      return Array.from({ length: daysInMonth }, (_, i) => ({
        value: i + 1,
        text: i + 1,
      }));
    },
    updatePeriodEnd() {
      const { month, day } = this.computedPeriodEnd;
      this.form.response.point.expiration.period_end_month = month;
      this.form.response.point.expiration.period_end_day = day;

      this.validateExpiryDate();
    },
    validateExpiryDate() {
      const offsetYears = this.form.response.point.expiration.expiry_offset_years;

      // 若過期年度為 0 年後，過期日需晚於年度終止日，其餘不受限
      if (offsetYears !== 0) return;
      const periodEndMonth = this.form.response.point.expiration.period_end_month;
      const periodEndDay = this.form.response.point.expiration.period_end_day;
      const expiryMonth = this.form.response.point.expiration.expiry_month;
      const expiryDay = this.form.response.point.expiration.expiry_day;

      const periodEndDate = new Date(
        new Date().getFullYear(),
        periodEndMonth - 1,
        periodEndDay
      );
      const expiryDate = new Date(
        new Date().getFullYear(),
        expiryMonth - 1,
        expiryDay
      );

      if (expiryDate <= periodEndDate) {
        this.form.response.point.expiration.expiry_month = periodEndMonth;
        this.form.response.point.expiration.expiry_day = periodEndDay;
      }
    },
  },
  watch: {
    "levelCondition.from_customer_level_id"(newValue) {
      if (newValue) {
        if (this.type === "customer_upgraded") {
          const fromLevel = this.customerLevelOptions.findIndex(level => level.value === newValue);
          this.levelCondition.to_customer_level_id = this.customerLevelOptions[fromLevel+1].value;
        }
        else if (this.type === "customer_downgraded") {
          const fromLevel = this.customerLevelOptions.findIndex(level => level.value === newValue);
          this.levelCondition.to_customer_level_id = this.customerLevelOptions[fromLevel-1]?.value ?? null;
        }
      }
    },
    "form.response.point.expiration.period_start_month"() {
      this.updatePeriodEnd();
    },
    "form.response.point.expiration.period_start_day"() {
      this.updatePeriodEnd();
    },
    "form.response.point.expiration.expiry_offset_years"() {
      this.validateExpiryDate();
    },
    "form.response.point.expiration.expiry_month"() {
      this.validateExpiryDate();
    },
    "form.response.point.expiration.expiry_day"() {
      this.validateExpiryDate();
    },
  },
};
</script>
<style lang="scss" scoped>
.accordion {
  .card {
    overflow: visible;
  }
}

::v-deep .form-control.is-invalid {
  border-color: #dc3545;
}
</style>